const Footer = () => {
  return (
    <div className="card footer">
      <h2>GitFind | Developed by Umang Nagar | &copy; 2022</h2>
      <a href="https://github.com/UmangNagar/Git-Finder-App" target="_blank" rel="noreferrer">Github Source Code</a>
      <p> Made with ❤️ &amp; 💻</p>
    </div>
  )
}

export default Footer;
